import React from 'react';
import { FaLinkedin, FaGithub } from 'react-icons/fa';
import { GITHUB, LINKEDIN } from '../social-urls';

const links = [
  { href: LINKEDIN, label: 'LinkedIn', handle: '/in/jonas-dormaels', Icon: FaLinkedin },
  { href: GITHUB, label: 'GitHub', handle: '/JonasDormaels', Icon: FaGithub },
];

const SocialCTAs = () => (
  <nav aria-label="Social links" className="flex flex-col border-b border-line">
    {links.map(({ href, label, handle, Icon }) => (
      <a
        key={label}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center gap-3.5 border-t border-line py-3.5 text-[17px] text-fg-strong transition-colors hover:text-mint focus-visible:text-mint focus-visible:outline-none"
      >
        <Icon aria-hidden="true" className="w-5 shrink-0 text-lg" />
        <span className="font-bold">{label}</span>
        <span className="min-w-0 flex-1 truncate text-[15px] text-muted">{handle}</span>
        <span aria-hidden="true">↗</span>
      </a>
    ))}
  </nav>
);

export default SocialCTAs;
